import { render, staticRenderFns } from "./BaseChessPlan.vue?vue&type=template&id=71f0c0c8&scoped=true"
import script from "./BaseChessPlan.vue?vue&type=script&lang=js"
export * from "./BaseChessPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f0c0c8",
  null
  
)

export default component.exports